import { render, staticRenderFns } from "./activityProfile.html?vue&type=template&id=04b45af4&scoped=true&external"
import script from "./activityProfile.vue?vue&type=script&lang=js"
export * from "./activityProfile.vue?vue&type=script&lang=js"
import style0 from "./activityProfile.css?vue&type=style&index=0&id=04b45af4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b45af4",
  null
  
)

export default component.exports